<template>
    <div>
        <!-- 我的贡献值 -->
        <div class="tab-list df">

            <div class="list df aic jcc">
                <span class="num">{{ info.user_score }}</span>
                <p class="t1">{{ $t('当前贡献值') }}</p>
                <img src="@/assets/images/bg2.png" class="bg" alt="">
            </div>
            <div class="list df aic jcc ml-16">
                <span class="num">{{ info.rank }}</span>
                <p class="t1">{{ $t('当前排名') }}</p>
                <img src="@/assets/images/bg1.png" class="bg" alt="">
            </div>
        </div>

        <div class="show-lv mt-26 pb-24 df aic">
            <div class="grade-title df aic jcc">
                <span class="title">{{ $t('当前等级') }}</span>
                <span class="num">Lv{{ info.user_points_level }}</span>
            </div>

            <div class="ml-24">
                <img :src="info.user_medal_front_icon_arr" style="max-height: 36px;" class="mr-16" mode="heightFix"
                    v-if="info.user_medal_front_icon_arr != ''">
                <img v-for="(image, index) in info.user_logo_front_icon_arr" :key="index" :src="image"
                    style="max-height: 36px;" class="mr-16" mode="heightFix">
            </div>
            
        </div>

        <div class="ts fw-b fs-20 mt-24">
            {{ $t('历史贡献值') }}
        </div>
        
        <el-table :data="dataList" style="width: 100%">
            <el-table-column prop="tupd_remarks"  :label="$t('内容')">
            </el-table-column>
            <el-table-column prop="create_time" :label="$t('时间')" align="center" width="160">
            </el-table-column>
            <el-table-column :label="$t('贡献值')" align="right" width="120">
                <template #default="{ row }">
                    <span>{{ row.tupd_type === 10 || row.tupd_type === 20 ? '+' : '-' }} {{ row.tupd_item_score }}</span>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->

        <div class="pageing-box df aic jcc mt-24" v-if="dataList.length > 0">
            <el-button type="text" class="add-btn" @click="handlePages(1)">{{ $t('回首页') }}</el-button>
            <el-pagination :current-page="pagination.page" :page-size="pagination.per_page" :total="pagination.total"
                layout=" prev, pager, next,slot" @current-change="handleCurrent">
                <span class="jump-text">{{ $t('跳转') }}</span>
                <el-input-number :controls="false" v-model="jumpIndex" :min="1" :max="totalPages" @change="handleJump"
                    size="small" class="jump-ipt" style="width: 48px; margin-left: 8px;" />
            </el-pagination>
            <el-button type="text" class="add-btn ml-11" @click="handlePages(totalPages)">{{ $t('去尾页') }}</el-button>
        </div>



    </div>
</template>

<script>
import { getscore } from "@api/usercenter";
export default {
    data() {
        return {
            info: {

            },

            // 分页
            pagination: {
                total: 0,
                page: 1,
                per_page: 16
            },
            jumpIndex: 1,
            totalPages: 1,



            dataList: [],

            tableData: []
        }
    },
    created() {
        this.getData();
    },
    methods: {
        getData() {
            getscore({page: this.pagination.page}).then((res) => {
                if (res.status == 200) {
                    this.info = res.data.info;
                    this.dataList = res.data.data;

                    this.pagination.total = res.data.total;
                    this.pagination.per_page = res.data.per_page;

                    this.totalPages = Math.ceil(this.pagination.total / this.pagination.per_page);

                }
            });
        },


        // 分页
        handlePages(page) {
            this.pagination.page = page;
            this.handleCurrent(page);
        },
        handleCurrent(page) {
            this.pagination.page = page;
            this.getData();

        },

        handleJump(){
            this.pagination.page = this.jumpIndex;
            this.getData();
        },

    }
}
</script>

<style lang="scss" scoped>
.show-lv {
    border-bottom: 1px dashed #b8bfd9;

    .grade-title {
        width: 100px;
        height: 24px;
        background-image: url("../../../assets/images/border.png");
        background-size: 100% 100%;
        line-height: 22px;

        .title {
            font-size: 12px;
            color: #1e5fdd;
            width: 65px;
            padding-left: 6px;
        }

        .num {
            text-align: center;
            font-size: 12px;
            color: #cb1126;
            width: 30px;
        }
    }
}

.tab-list {
    .list {
        width: 240px;
        height: 114px;
        background: #f0f5ff;
        border-radius: 8px;
        border: 1px solid transparent;
        box-shadow: 0px 8px 32px 0px rgba(220, 220, 220, 0.1);
        background-clip: padding-box, border-box;
        background-origin: padding-box, border-box;
        background-image: linear-gradient(180deg, #f0f5ff 0%, #f0f5ff 30px, #f0f5ff 100%), linear-gradient(to bottom, #cee0fd, #ebf2ff);
        position: relative;
        z-index: 1;
        overflow: hidden;

        .num {
            font-weight: 700;
            font-size: 22px;
            color: #1e5fdd;
            transition: all 0.4s;
        }

        .t1 {
            font-size: 16px;
            color: #040a16;
            display: inline-block;
            margin-left: 12px;
        }

        .bg {
            position: absolute;
            right: -34px;
            top: 35px;
            z-index: -1;
        }
    }
}
</style>